<script>
export default {
    name: 'CalendarDateYear',
    props: {
        year: {
            type: Number,
            required: true
        },
        formattedDate: {
            type: Object,
            required: true
        }
    }
};
</script>

<template>
    <span
        class="text-sl-v3"
        :class="[
            year === formattedDate.year
                ? 'bg-main-dark shadow-base cursor-auto cursor-auto rounded-[50px] px-[36px] font-semibold text-white'
                : 'cursor-pointer'
        ]"
        >{{ year }}</span
    >
</template>
